<template>
  <page-container id="page-order" @window-return="windowReturn">
    <div style="background-color:#fff;padding:10px 0;">
      <div class="el-tabs el-tabs--card el-tabs--top">
        <div class="el-tabs__header is-top" style="margin:0;">
          <div class="el-tabs__nav-wrap is-top">
            <div class="el-tabs__nav-scroll">
              <div role="tablist" class="el-tabs__nav is-top" style="transform: translateX(0px);">
                <div v-for="tab in tabs" :key="tab.path" :class="['el-tabs__item', 'is-top', $route.path.indexOf(tab.path) >= 0 ? 'is-active' : '']" @click="goPath(tab.path)">{{ tab.title }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <router-view ref="routerView"/>
  </page-container>
</template>

<script>
export default {
  data () {
    return {
      tabs: [
        { path: '/order/po', title: 'PO' },
        { path: '/order/invoice', title: 'Invoice' },
        { path: '/order/delivery-note', title: 'Delivery Note' },
        { path: '/order/packing-list', title: 'Packing List' }
      ]
    }
  },
  methods: {
    goPath (path) {
      this.$router.replace(path)
    },
    windowReturn () {
      this.$refs.routerView && this.$refs.routerView.refresh()
    }
  }
}
</script>

<style lang="scss">
#page-order {
  .detail-table td {
    padding-top: 8px;
  }
}
</style>